import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { SAE_ACTION_CONTROLS, SAE_OPT_OUTS_BY_STUDENT } from "../const/SaeConst";

/**
 * Data Access for the Student Assessments Excusals Service
 * @name SaeDao
 * @param {*} props
 */
const SaeDao = (props) => {
    const { action, schoolYearKey, studentNumber, token } = props;

    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "saeActionControlsRead":
            options.method = "GET";
            options.url = `${SAE_ACTION_CONTROLS}/${schoolYearKey}/index.json`;
            break;
        case "saeOptOutsByStudentRead":
            options.method = "GET";
            options.url = `${SAE_OPT_OUTS_BY_STUDENT}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

SaeDao.propTypes = {
    action: PropTypes.string.isRequired,
    schoolYearKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studentNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    token: PropTypes.string.isRequired
};

SaeDao.defaultProps = {
    schoolYearKey: null,
    studentNumber: null
};

export default SaeDao;
